import React from 'react'


export default function PrivacyPolicy() {
  const bannerstyle = {
    margin: '0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', 
    paddingBottom: '3%'
  }
  
  return (
    <div>
      
        <section className="banner" style={bannerstyle}>
           <div className="container-fluid">
               <div className="row">
                   <div className="col-md-12 p-0">
                       <div className="sub-banner">
                          <img src="/assets/img/banner-privacy-policy.jpg" className="d-block w-100" alt="..." />
                          
  
                       </div>
                   </div>
               </div>
           </div>
           <div className="container aboutHead">
                <div className="row">
                    <div className="col-md-12">
                         <h1>Privacy Policy</h1>
                    </div>
                </div>
           </div>
       </section>

<section className="privacy"> 
      <div className="container">
        <div className='row'>
          <div className='col-md-12 my-4'>
            
  <p>
    Unlock Destinations ("Unlock Destinations", "Company", "we", "us", "our") values the trust you place in us when you choose our services. This Privacy Policy ("Policy") explains in detail how we collect, use, store, share and protect your personal data when you engage with our website, mobile application, booking channels (including WhatsApp and email) or otherwise interact with us. This Policy also outlines your rights and choices with respect to your personal data.
  </p>

  <h2>Applicability</h2>
  <ul>
    <li>All customers and travellers, both within India and overseas including foreign nationals who book or participate in any trip, tour, event or service organised or facilitated by Unlock Destinations.</li>
    <li>Website visitors and users who access or interact with our website, mobile platforms, booking forms, WhatsApp groups, email communication channels, or any other digital or offline medium operated by Unlock Destinations.</li>
    <li>Prospective clients and leads who provide their data during enquiries, promotional campaigns or marketing interactions even if no booking is ultimately made.</li>
    <li>Any other individuals whose personal data is received or processed by Unlock Destinations including guardians/parents providing information for minors or nominees providing emergency contact details.</li>
  </ul>

  <p>
    By using our services, you acknowledge that you have read and understood this Policy and consent to the practices described herein.
  </p>

  <h2>Information We Collect</h2>
  <ul>
    <li><strong>Personal details:</strong> Name, phone number, email, address.</li>
    <li><strong>Travel details:</strong> Destination preferences, travel dates, passport details (for bookings only).</li>
    <li><strong>Payment information:</strong> Processed securely through third-party payment gateways.</li>
    <li><strong>Technical data:</strong> IP address, browser type, device information, and cookies.</li>
    <li><strong>Communication data:</strong> Chats, emails, WhatsApp messages for service purposes.</li>
  </ul>

  <h2>How We Use Your Information</h2>
  <ul>
    <li>Process bookings, payments, and travel documentation.</li>
    <li>Provide itineraries, quotations, and customer support.</li>
    <li>Improve website performance and user experience.</li>
    <li>Send offers, updates, and travel-related communication (only with consent).</li>
    <li>Maintain legal and accounting records.</li>
  </ul>

  <h2>Sharing of Information</h2>
  <p>We share your data only when necessary, such as with:</p>
  <ul>
    <li>Airlines, hotels, travel partners, and ground handlers.</li>
    <li>Payment gateways and financial institutions.</li>
    <li>Legal authorities if required by law.</li>
  </ul>
  <p><strong>We never sell your personal information.</strong></p>

  <h2>How We Keep Your Information Safe</h2>
  <p>
    We take the security of your personal information seriously and implement industry-standard measures to protect it from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is completely secure. While we strive to protect your data, we cannot guarantee absolute security. We also advise you not to share your OTPs with anyone, even if they claim to be from “Unlock Destinations Support.”
  </p>

  <h2>Your Rights</h2>
  <ul>
    <li><strong>Access & Update:</strong> You may request to update your personal information anytime.</li>
    <li><strong>Data Deletion:</strong> You may request deletion of your personal data by contacting us.</li>
    <li><strong>Unsubscribe:</strong> You can opt out of marketing communications at any time.</li>
  </ul>

  <h2>Cookies</h2>
  <p>
    We use cookies to understand how users interact with our content and to improve the browsing experience. You can disable cookies via your browser settings; however, some features may not function properly.
  </p>

  <ul>
    <li><strong>Essential Cookies:</strong> Required for website functionality.</li>
    <li><strong>Performance Cookies:</strong> Help analyze website usage (e.g., Google Analytics).</li>
    <li><strong>Functional Cookies:</strong> Remember user preferences.</li>
    <li><strong>Advertising/Targeting Cookies:</strong> Used to deliver relevant ads.</li>
  </ul>

  <h2>Updates to This Policy</h2>
  <p>
    We may update this Privacy Policy from time to time to reflect changes in legal requirements or business practices. Any updates will be posted on our website, and users are encouraged to review this page periodically.
  </p>

  <h2>Contact Us</h2>
  <div class="contact-box">
    <p><strong>Phone Number:</strong> +91 8766234500</p>
    <p><strong>Email:</strong> Info@unlockdestinations.in</p>
  </div>

  <p class="footer-note">
    Thank you for choosing Unlock Destinations. We are committed to protecting your privacy and ensuring a safe travel experience.
  </p>
</div>

   </div> 
    </div>
    </section>
            

    </div>
  )
}
